import { render, staticRenderFns } from "./NoteCount.vue?vue&type=template&id=de909c7e&"
import script from "./NoteCount.vue?vue&type=script&lang=js&"
export * from "./NoteCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports